import styled from 'styled-components';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import { BodyText, Tooltip } from '@block-explorer/ui';
import { AccountInfoIcon } from '../../account-info-icon/account-info-icon';
import {
  ACCOUNT_DETAILS_PATH,
  VALIDATOR_DETAILS_PATH,
} from '../../../router/paths';
import React from 'react';
import { SHORTENED_ENTRY_TYPE_LENGTH, truncateName } from '../utils';
import { Deploy } from '@block-explorer/entities';
import { auctionMessage } from '../../../services/deploy-action-messages';
import { useAccountInfoContext } from '../../../services/account-data-service';
import { buildRouterPath } from '../../../router/utils';
import { DefaultActionMessage } from './default-action-message';
import { ContractIdentifier } from '../../contract-identifier/contract-identifier';
import { useTranslation } from 'react-i18next';

const EntryTypeRow = styled(FlexRow)(() => ({
  maxWidth: '25rem',
}));
export const AuctionActionMessage = ({ deploy }: { deploy: Deploy }) => {
  const { t } = useTranslation();
  const { getAccountInfo } = useAccountInfoContext();
  const message = auctionMessage().prepareActionMessageData(
    deploy,
    getAccountInfo,
    t
  );

  if (!message) {
    return <DefaultActionMessage deploy={deploy} />;
  }

  return (
    <FlexColumn>
      <EntryTypeRow align={'baseline'} itemsSpacing={4}>
        <FlexRow itemsSpacing={6} align={'baseline'}>
          <Tooltip tooltipContent={message.entryPointName}>
            <BodyText monotype size={3} wordBreak noWrap>
              {truncateName(message.actionName, SHORTENED_ENTRY_TYPE_LENGTH)}
            </BodyText>
          </Tooltip>
        </FlexRow>
        <BodyText size={3} variation={'darkGray'}>
          <FlexRow itemsSpacing={6} align={'center'}>
            {message.callerAccount && message.callerAccount.publicKey && (
              <>
                {message.callerPrefix && <span>{message.callerPrefix}</span>}
                <AccountInfoIcon
                  publicKey={message.callerAccount.publicKey}
                  logo={null}
                  path={buildRouterPath(
                    ACCOUNT_DETAILS_PATH,
                    { id: message.callerAccount?.publicKey },
                    undefined
                  )}
                />
              </>
            )}
            {message.account1 && message.account1.publicKey && (
              <>
                {message.prefix1 && <span>{message.prefix1}</span>}
                <AccountInfoIcon
                  publicKey={message.account1.publicKey}
                  logo={message.account1.logo || null}
                  path={buildRouterPath(
                    VALIDATOR_DETAILS_PATH,
                    { id: message.account1?.publicKey },
                    undefined
                  )}
                />
              </>
            )}
            {message.account2 && message.account2.publicKey && (
              <>
                {message.prefix2 && <span>{message.prefix2}</span>}
                <AccountInfoIcon
                  publicKey={message.account2.publicKey}
                  logo={message.account2.logo || null}
                  path={buildRouterPath(
                    VALIDATOR_DETAILS_PATH,
                    { id: message.account2?.publicKey },
                    undefined
                  )}
                />
              </>
            )}
          </FlexRow>
        </BodyText>{' '}
      </EntryTypeRow>
      <FlexRow itemsSpacing={4}>
        <BodyText variation={'darkGray'} size={3}>
          with
        </BodyText>
        <ContractIdentifier
          hash={deploy.contractPackage.contract_package_hash}
          contractPackage={deploy.contractPackage}
        />
      </FlexRow>
    </FlexColumn>
  );
};
